<template>
  <g>
    <path
      fill="none"
      d="M0 0h24v24H0z"
    />
    <path
      d="M11.44 5.89v-.11l-.1-.11a.1.1 0 01-.12.1 4.52 4.52 0 000 2.45 15.12 15.12 0 00.22-2.33zm-3.55 10a2.43 2.43 0 00-.56.33A5.47 5.47 0 005.9 18c.67-.11 1.33-.78 2-2.11zm10.22-1.67c-.11-.1-.56-.44-2.11-.44h-.22v.1a5.96 5.96 0 002.1.56h.34v-.1a.1.1 0 01-.11-.12zM19.78 2H4.22A2.23 2.23 0 002 4.22v15.56A2.23 2.23 0 004.22 22h15.56A2.23 2.23 0 0022 19.78V4.22A2.23 2.23 0 0019.78 2zm-1.22 13.11a2.22 2.22 0 01-1 .22 8.01 8.01 0 01-3.34-.77 18.3 18.3 0 00-4.44.88c-.11 0-.11 0-.22.11C8.22 17.9 7.1 19 6.22 19c-.22 0-.33 0-.44-.11l-.56-.33v-.11a1 1 0 01-.1-.56 4.28 4.28 0 012.1-2.33c.22-.12.56-.34 1-.56.34-.56.67-1.22 1.11-2a23.5 23.5 0 001.23-3.22 5.16 5.16 0 01-.23-3.67c.12-.44.45-.89.9-.89h.22a1.58 1.58 0 01.66.22c.78.78.45 2.56 0 4v.11a8.03 8.03 0 001.78 2.9 7.8 7.8 0 001 .66c.56 0 1-.11 1.44-.11 1.34 0 2.23.22 2.56.78a1.4 1.4 0 01.11.66 6.8 6.8 0 01-.44.67zm-7.23-4.33a23.14 23.14 0 01-1.1 2.67c-.23.44-.45.77-.68 1.22h.23a16.8 16.8 0 013.66-1 1.53 1.53 0 01-.44-.34 11.3 11.3 0 01-1.67-2.55z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </g>
</template>
